import * as yup from 'yup';
import i18n from '@/i18n';

yup.setLocale({
    mixed: {
        required: () => i18n.t('required'),
    },
    string: {
        email: () => i18n.t('invalidEmail'),
        max: ({ max }: { max: number }) => i18n.t('maxLength', { max }),
        min: ({ min }: { min: number }) => i18n.t('minLength', { min }),
        matches: () => i18n.t('matches'),
    },
});

export * from 'yup';
